import { useQuery } from '@tanstack/react-query';
import { feedbackService } from 'shared/src/api';
import type { FeedbackType } from 'shared/src/api/feedbackService/types';

export const useGetFeedbackTitles = ({
  feedbackType,
  goodsSno,
  enabled,
}: {
  feedbackType: FeedbackType;
  goodsSno: number;
  enabled: boolean;
}) => {
  return useQuery({
    queryKey: ['feedbackTitles', feedbackType, goodsSno],
    queryFn: () =>
      feedbackService
        .getFeedbackTitles({ feedbackType, goodsSno })
        .then(res => res.data),
    enabled,
  });
};
